import { render } from "./ContactsEntityList.vue?vue&type=template&id=0f630eac"
import script from "./ContactsEntityList.vue?vue&type=script&lang=js"
export * from "./ContactsEntityList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__